(ns ductile.ui.locale
  {:clj-kondo/config '{:linters {:discouraged-var {malli.error/humanize {:level :off}}}}}
  (:require #?@(:clj [[clojure.edn :as edn]
                      [clojure.java.io :as io]]
                :cljs [[reagent.core :as r]])
            [clojure.string :as str]
            [malli.core :as m]
            [malli.error :as me])
  #?(:cljs (:require-macros [ductile.ui.slurp-tr-edn-macro :refer [slurp-tr-edn]]))
  #?(:cljs (:import [goog.net Cookies])))

(def supported-languages [:en :de :it])
(def supported-languages-set (set supported-languages))
(def default-language :en)
(def language-label {:en "English"
                     :de "Deutsch"
                     :it "Italiano"})

(def ->iso-locale
  {:en "en-GB"
   :de "de-DE"
   :it "it-IT"})

#?(:cljs (defonce !missing-translations (atom #{})))

(defn select-language [preferred-language]
  (if (supported-languages-set preferred-language)
    preferred-language
    default-language))

#?(:cljs
   (defn detect-browser-language []
     (some-> (when (exists? js/window) (.. js/window -navigator -language))
             (str/split "-")
             first
             keyword)))

(def !current-locale
  #?(:cljs (r/atom (or (and (exists? js/document)
                            (let [cookies (Cookies. js/document)]
                              (some-> (.get cookies "current-locale" nil) keyword)))
                       (select-language (detect-browser-language))))
     :clj  (atom default-language)))

(def ^:dynamic *current-locale* nil)

#?(:cljs
   (add-watch !current-locale ::current-locale
              (fn [_ _ _ newval]
                (when (exists? js/document)
                  (let [cookies (Cookies. js/document)]
                    (.set cookies "current-locale" (name newval) #js {:path "/"}))))))

(defn ^:export set-locale! [locale]
  (reset! !current-locale (keyword locale)))

(defn get-current-locale []
  (or *current-locale* @!current-locale))

(defn get-current-iso-locale []
  (->iso-locale (or *current-locale* @!current-locale)))

(def index-of-locale
  "Order of locales in trple => {:en 0 :de 1 :it 2}"
  (into {} (map-indexed (comp vec reverse vector) supported-languages)))

(defn trple-get
  "Extract value in locale from trple"
  [to-locale trple]
  (cond
    (and (= :keyword to-locale)
         (contains? supported-languages-set (first trple)))
    nil

    (and
     (= :keyword to-locale)
     (keyword? (first trple)))
    (first trple)

    :else
    (get trple (cond-> (index-of-locale to-locale)
                 (keyword? (first trple)) inc))))

(defn tr-key [[source & locales :as trple]]
  (if (supported-languages-set source)
    [source (trple-get source trple)]
    source))

(defn index-by
  "Returns map of source locale to trple"
  [locale trples]
  (into {}
        (comp (map (juxt (partial trple-get locale) identity))
              (remove (comp nil? first)))
        trples))

(defn from-to [from to trples]
  (update-vals (index-by from trples)
               (partial trple-get to)))

(def all-translations
  ;; CLJ only: Read tr.edn at runtime to avoid compiler exception: Method code too large
  (let [trples #?(:clj (edn/read-string (str "[" (slurp (or (io/resource "tr.edn") "resources/tr.edn")) "]"))
                  :cljs (slurp-tr-edn))]
    (->>
     (for [from (conj supported-languages :keyword)
           to (conj supported-languages :keyword)
           :when (not= from to)]
       (let [from-to-map (from-to from to trples)]
         {from {to from-to-map}}))
     (apply merge-with merge))))

(defn has-translation? [k]
  (or (contains? (get-in all-translations [:en (get-current-locale)]) k)
      (contains? (get-in all-translations [:keyword (get-current-locale)]) k)))

(defn replace-args
  "Replace placeholders in s with sequential (%1, %2...) or map args {:name ... :count ...})"
  [s args]
  (cond
    (not (string? s)) s

    (and (seq args) (map? (first args)))
    (reduce (fn [acc [k v]] (str/replace acc (str k) (str v))) s (first args))

    (sequential? args)
    (reduce (fn [acc [i arg]] (str/replace acc (str "%" (inc i)) (str arg)))
            s
            (map-indexed vector args))

    :else s))

#?(:cljs
   (defn missing-translation! [from to s args]
     (let [args {:from from :to to :s s :args args}]
       (swap! !missing-translations conj [from to s])
       (js/console.warn "missing translation" (str s)))))

(defn translate
  ([from to s] (translate from to s nil))
  ([from to s args]
   (if-not s
     nil
     (if-let [lang-label (and (keyword? s) (language-label s))]
       lang-label
       (let [from (if (keyword? s) :keyword from)
             translated (if (= from to) s
                            (get-in all-translations [from to s]))
             fallback (if (and (str/blank? (str translated))
                               (not= from to default-language)
                               (not= from to))
                        (get-in all-translations [from default-language s] s)
                        translated)
             replaced (if (seq args)
                        (replace-args fallback args)
                        fallback)]
         #?(:cljs
            (when (and (not (str/blank? s))
                       (or (keyword? replaced)
                           (str/blank? replaced)))
              (missing-translation! from to s args)))
         (if (str/blank? (str replaced)) nil (str replaced)))))))

(defn tr [s & args] (translate :en (get-current-locale) s args))
(defn tr-de [s & args] (translate :de (get-current-locale) s args))
(defn tr-it [s & args] (translate :it (get-current-locale) s args))

(comment
  (tr "VIN: %1 and ARS-ID: %2" "WBAJD51080BL18963" "OK12345678901234567890")
  (tr "VIN: :vehicle/vin and ARS-ID: :ars/id" {:vehicle/vin "WBAJD51080BL18963" :ars/id "OK12345678901234567890"}))

(def number-separators
  {:en [\, \.]
   :de [\. \,]
   :it [\. \,]})

(defn current-number-separators []
  (number-separators (get-current-locale)))

(def translated-column-headers
  "Keys for column headers with their translation
  as a vector of form `[key1 (tr \"translation1\") key2 …]`
  to allow specifying a default order of columns"
  ;;needed to make pottery pick up the translations
  (let [tr identity]
    [:transport/ars-truck? "ARS Truck?"
     :compound/name "Compound"
     :takeover/during-day? "Takeover during the day?"
     :takeover/during-ice-snow? "Takeover during ice and snow?"
     :condition/in-order? "Condition in order?"
     :contract/ordered-services "Ordered services"
     :vehicle/vin "VIN"
     :vehicle/make "Make"
     :make/name "Make"
     :vehicle/model "Model"
     :vehicle/engine-type "Engine type"
     :engine.type/plug-in-hybrid "plug-in hybrid"
     :engine.type/electric "electric"
     :engine.type/internal-combustion "internal combustion"
     :engine.type/hybrid "hybrid"
     :fahrzeug/parking-spot "Parking spot"
     :fuel/type "Fuel type"
     :fuel.type/petrol "Petrol"
     :fuel.type/diesel "Diesel"
     :fuel.type/electricity "Electricity"
     :fuel.type/ethanol "Ethanol"
     :fuel.type/lpg "LPG"
     :ductile/id "Ductile ID"
     :ars/id "ARS-ID"
     :vehicle/blocks "blocks"
     :vehicle/condition "Vehicle Condition"
     :vehicle.condition/new "new"
     :vehicle.condition/damaged "damaged"
     :vehicle/license-plate "License plate"
     :vehicle/mileage "Mileage"
     :vehicle/new? "New?"
     :vehicle/quarantine-required? "Quarantine required"
     :vehicle/dimensions "Dimensions"
     :vehicle/length-mm "Length (mm)"
     :vehicle/width-mm "Width (mm)"
     :vehicle/height-mm "Height (mm)"
     :vehicle/weight "Weight"
     :vehicle/equipment "Equipment"
     :vehicle/roadworthy? "roadworthy"
     :vehicle/leaktight? "leaktight"
     :vehicle.status/battery-voltage "battery charge"
     :vehicle.status/battery-status "battery status"
     :vehicle.status/high-voltage-battery-charge-kwh "HV battery charge"
     :vehicle.status/hv-battery-charge "HV battery charge"
     :vehicle.status/hv-battery-unit "HV battery unit"
     :color/description "Color"
     :color/gradient-from "Color gradient from"
     :color/gradient-to "Color gradient to"
     :external.bmw/color-code "BMW color code"
     :external.kia/model-code "KIA model code"
     :external.bmw/model-code "BMW model code"
     :transport/name "Transport name"
     :transport/number "Transport number"
     :transport/mode "Transport mode"
     :transport/loading-line "loading line"
     :transport/origin "transport origin"
     :transport/destination "transport destination"
     :transport/license-plate "License Plate"
     :transport/driver-name "Driver"
     :truck/number "Truck number"
     :entry/transport "Entry transport"
     :entry/datetime "Entry datetime"
     :entry/expected-datetime "Expected entry date"
     :entry/mode "Entry mode"
     :entry/transport-order "Entry transport order"
     :entry/unloading-line "unloading line"
     :entry-transport-order/transport-name "Entry transport order transport name"
     :entry-transport-order/destination-location-location-name "Entry transport order destination location name"
     :entry-transport-order/destination-location-compound-name "Entry transport order destination compound name"
     :entry-transport-order/destination-location-address-name "Entry transport order destination address name"
     :entry-transport-order/destination-location-address-street "Entry transport order destination street"
     :entry-transport-order/destination-location-address-postcode "Entry transport order destination postcode"
     :entry-transport-order/destination-location-address-city "Entry transport order destination city"
     :entry-transport-order/destination-location-address-province-code "Entry transport order destination province"
     :entry-transport-order/destination-location-address-country-country-code "Entry transport order destination country"
     :entry-transport-order/destination-location-external.bmw-location-codes "Entry transport order destination BMW location codes"
     :entry-transport-order/destination-location-external.kia-location-codes "Entry transport order destination BMW location codes"
     :entry-transport-order/destination-location-location-latitude "Entry transport order destination latitude"
     :entry-transport-order/destination-location-location-longitude "Entry transport order destination longitude"
     :entry-transport-order/external.bmw-carrier-code "Entry transport order BMW carrier code"
     :entry-transport-order/external.bmw-spediteur "Entry transport order BMW spediteur"
     :entry-transport-order/origin-location-location-name "Entry transport order origin location"
     :entry-transport-order/origin-location-compound-name "Entry transport order origin compound name"
     :entry-transport-order/origin-location-address-name "Entry transport order origin address name"
     :entry-transport-order/origin-location-address-street "Entry transport order origin street"
     :entry-transport-order/origin-location-address-postcode "Entry transport order origin postcode"
     :entry-transport-order/origin-location-address-city "Entry transport order origin city"
     :entry-transport-order/origin-location-address-province-code "Entry transport order origin province"
     :entry-transport-order/origin-location-address-region "Entry transport order origin region"
     :entry-transport-order/origin-location-address-country-country-code "Entry transport order origin country"
     :entry-transport-order/origin-location-external.bmw-location-codes "Entry transport order origin BMW location codes"
     :entry-transport-order/origin-location-external.kia-location-codes "Entry transport order origin KIA location codes"
     :entry-transport-order/origin-location-location-latitude "Entry transport order origin latitude"
     :entry-transport-order/origin-location-location-longitude "Entry transport order origin longitude"
     :entry-transport-order/transport-load-number "Entry transport order load number"
     :entry-transport-order/transport-mode "Entry transport order mode"
     :entry-transport/transport-name "Entry transport name"
     :entry-transport/transport-mode "Entry transport mode"
     :entry-transport/exit-datetime "Entry transport exit date"
     :entry-transport/transport-license-plate "Entry transport license plate"
     :entry-transport/destination-location-compound-name "Entry transport destination compound name"
     :entry-transport/destination-location-address-street "Entry transport destination street"
     :entry-transport/destination-location-address-postcode "Entry transport destination postcode"
     :entry-transport/destination-location-address-city "Entry transport destination city"
     :entry-transport/destination-location-address-province-code "Entry transport destination province"
     :entry-transport/destination-location-address-country-country-code "Entry transport destination city"
     :entry-transport/destination-location-external.kia-location-codes "Entry transport destination KIA location codes"
     :parking-spot "Parking spot"
     :parking-spot/zone "Parking spot zone"
     :parking-zone/name "Parking spot zone"
     :parking-spot/row "Parking spot row"
     :parking-spot/place "Parking spot place"
     :contract/name "Contract"
     :contract/framework-contract "Framework Contract"
     :dispo/flag "flagged as"
     :address/name "Address name"
     :address/street "Street"
     :address/postcode "Postcode"
     :address/city "City"
     :address/country "Country"
     :location/latitude "Latitude"
     :location/longitude "Longitude"
     :customer/name "Customer"
     :exit/datetime "Exit datetime"
     :exit/expected-datetime "Expected exit date"
     :exit/transport "Exit transport"
     :exit-transport-order/transport-mode "Exit transport order mode"
     :exit-transport-order/external.bmw-carrier-code "Exit transport order BMW carrier code"
     :exit-transport-order/external.bmw-spediteur "Exit transport order BMW spediteur"
     :exit-transport-order/origin-location-compound-name "Exit transport order origin compound"
     :exit-transport-order/origin-location-address-name "Exit transport order origin address name"
     :exit-transport-order/origin-location-address-street "Exit transport order origin street"
     :exit-transport-order/origin-location-address-postcode "Exit transport order origin postcode"
     :exit-transport-order/origin-location-address-city "Exit transport order origin city"
     :exit-transport-order/origin-location-address-province-code "Exit transport order origin province"
     :exit-transport-order/origin-location-address-country-country-code "Exit transport order origin country"
     :exit-transport-order/origin-location-external.bmw-location-codes "Exit transport order origin BMW location codes"
     :exit-transport-order/origin-location-external.kia-location-codes "Exit transport order origin KIA location codes"
     :exit-transport-order/origin-location-location-latitude "Exit transport order origin latitude"
     :exit-transport-order/origin-location-location-longitude "Exit transport order origin longitude"
     :exit-transport-order/destination-location-address-name "Exit transport order destination location"
     :exit-transport-order/destination-location-location-delivery-modalities "Delivery modalities"
     :exit-transport-order/destination-location-location-name "Exit transport order destination location"
     :exit-transport-order/destination-location-address-street "Exit transport order destination address"
     :exit-transport-order/destination-location-address-postcode "Exit transport order destination postcode"
     :exit-transport-order/destination-location-address-city "Exit transport order destination city"
     :exit-transport-order/destination-location-address-province-code "Exit transport order destination province"
     :exit-transport-order/destination-location-address-region "Exit transport order destination region"
     :exit-transport-order/destination-location-address-country-country-code "Exit transport order destination country"
     :exit-transport-order/destination-location-external.bmw-location-codes "Exit transport order destination BMW location codes"
     :exit-transport-order/destination-location-external.kia-location-codes "Exit transport order destination KIA location codes"
     :exit-transport-order/destination-location-location-latitude "Exit transport order destination latitude"
     :exit-transport-order/destination-location-location-longitude "Exit transport order destination longitude"
     :exit-transport-order/external.pegaso-status "Exit transport order Pegaso status"
     :exit-transport-order/external.pegaso-transport-id "Exit transport order Pegaso transport ID"
     :exit-transport/load-id "Exit transport load ID"
     :exit-transport/origin-location-address-name "Exit transport origin address name"
     :exit-transport/origin-location-address-street "Exit transport origin street"
     :exit-transport/origin-location-address-postcode "Exit transport origin postcode"
     :exit-transport/origin-location-address-city "Exit transport origin city"
     :exit-transport/origin-location-address-country-country-code "Exit transport origin country"
     :exit-transport/origin-location-external.bmw-location-codes "Exit transport origin BMW location codes"
     :exit-transport/origin-location-location-latitude "Exit transport origin latitude"
     :exit-transport/origin-location-location-longitude "Exit transport origin longitude"
     :exit-transport/transport-loading-line-parking-spot-zone-parking-zone-name "Exit transport loading line parking spot zone"
     :exit-transport/transport-loading-line-parking-spot-row "Exit transport loading line parking spot row"
     :exit-transport/transport-mode "Exit transport mode"
     :exit-transport/transport-name "Exit transport name"
     :exit-transport/transport-ready-at "Exit transport ready at"
     :exit-transport/transport-driver-name "Exit transport driver name"
     :exit-transport/transport-license-plate "Exit transport license plate"
     :exit-transport/transport-load-number "Exit transport load number"
     :exit-transport/external.pegaso-load-number "Exit transport Pegaso load number"
     :exit-transport/external.pegaso-status "Exit transport Pegaso status"
     :exit-transport/transport-transporter-transport-carrier-company-name "Exit transporter carrier company name"
     :exit-transport/transport-transporter-transport-carrier-address-name "Exit transporter carrier address"
     :exit-transport/transport-transporter-transport-carrier-address-street "Exit transporter carrier street"
     :exit-transport/transport-transporter-transport-carrier-address-city "Exit transporter carrier city"
     :exit-transport/transport-transporter-transport-carrier-address-postcode "Exit transporter carrier postcode"
     :exit-transport/transport-transporter-transport-license-plate "Exit transporter license plate"
     :exit-transport/transport-transporter-truck-number "Exit transporter truck number"
     :fahrzeug-destination/address-city "Destination city" "Zielort" "Città destinazione"
     :fahrzeug-destination/address-country-country-code "Destination country" "Zielland" "Paese destinazione"
     :fahrzeug-destination/address-name "Destination address" "Zieladresse" "Indirizzo destinazione"
     :fahrzeug-destination/address-postcode "Destination postcode" "Ziel PLZ" "CAP destinazione"
     :fahrzeug-destination/address-province-code "Destination province" "Zielprovinz" "Provincia destinazione"
     :fahrzeug-destination/address-region "Destination region" "Zielregion" "Regione destinazione"
     :fahrzeug-destination/address-street "Destination street" "Zielstrasse" "Strada destinazione"
     :fahrzeug-destination/compound-name "Destination compound name" "Zielniederlassung" "Piazzale destinazione"
     :fahrzeug/workflow "Workflow"
     :workflow/code "Workflow"
     :fahrzeug/damages "damages"
     :fahrzeug/priority "Priority"
     :fahrzeug/expected-customer-delivery-datetime "Expected customer delivery date"
     :fahrzeug/customs-number "Customs number"
     :fahrzeug/customs-clearance "customs clearance"
     :fahrzeug/lagerfahrzeug "Lagerfahrzeug"
     :storage/entry-datetime "Storage entry at"
     :storage/exit-datetime "Storage exit at"
     :fahrzeug/storage-care-start-datetime "storage care start datetime"
     :fahrzeug/call-off-datetime "call off date"
     :fahrzeug/order-number "Order number"
     :fahrzeug/attributes "Vehicle attributes"
     :dispo/available-datetime "Dispo date"
     :mode/truck "truck"
     :mode/train "train"
     :mode/ship "ship"
     :mode/own-wheels "own wheels"
     :photo/vehicle-front "Photo of Vehicle Front"
     :photo/vehicle-back "Photo of Vehicle Back"
     :photo/vehicle-left "Photo of Vehicle Left"
     :photo/vehicle-right "Photo of Vehicle Right"
     :photo/vehicle-vin "Photo of Vehicle VIN"
     :photo/cmr "Photo of CMR"
     :photo/damages "Damages Photos"
     :photo/details "Detail Photos"
     :photo/entstromung "Photo of Vehicle Entstromung"
     :user/email "User Email"
     :service/code "service code"
     :service/template-quantity "template quantity"
     :service/completed-at "completed at"
     :service/manually-ordered-at "ordered at"
     :block/by-compound "blocked by compound"
     :block/by-customer "blocked by customer"
     :block/by-edi "blocked by EDI"
     :block/market-introduction "blocked by market introduction"
     :bmw-destination-0 "BMW destination 0"
     :bmw-destination-1 "BMW destination 1"
     :bmw-destination-2 "BMW destination 2"
     :invoice/invoice-number "Invoice number"
     :billing/amount "Amount (net)"
     :event/kind "Service event"
     :service.event/invoiced "invoiced"
     :service.event/completed "completed"
     :service.event/ordered "ordered"
     :service.event/canceled "canceled"
     :service.event/undone "undone"
     :service.event/edited "edited"
     :self-pickup "self pickup"
     :fahrzeug/labels "Labels"
     :label/quick-turnaround "Quick turnaround"
     :dispo/STA "STA"
     :dispo/TRADE "TRADE"
     :label/tnr-mini "TNR Mini"
     :label/all-risk-insurance "All-Risk Insurance"
     :unit/bar "bar"
     :unit/day "day"
     :unit/hour "hour"
     :unit/km "km"
     :unit/kwh "kWh"
     :unit/liter "Liter"
     :unit/percentage "percentage"
     :unit/volt "Volt"
     :vehicle.condition/damaged "damaged"
     :vehicle.condition/new "new"
     :vehicle.rims/aluminium "Aluminium"
     :vehicle.rims/none "No Rims"
     :vehicle.rims/steel "Steel"
     :vehicle.status/battery-charge "battery charge"
     :vehicle.status/battery-status "battery status"
     :vehicle.status/high-voltage-battery-charge "HV battery charge"
     :vehicle.status/high-voltage-battery-thermal-check "HV battery thermal check"
     :vehicle.status/hv-battery-charge "HV battery charge"
     :vehicle.status/hv-battery-unit "HV battery unit"
     :vehicle.tires/all-weather "All-weather"
     :vehicle.tires/none "No tires"
     :vehicle.tires/summer "Summer"
     :vehicle.tires/winter "Winter"
     :vehicle/accident? "Accident vehicle"
     :vehicle/blocks "blocks"
     :vehicle/condition "Vehicle Condition"
     :vehicle/damages "Damages"
     :vehicle/damages-inside "Damages inside"
     :vehicle/damages-outside "Damage outside"
     :vehicle/dimensions "Dimensions"
     :vehicle/depowered? "Depowered?"
     :vehicle/engine-type "Engine type"
     :vehicle/equipment "Equipment"
     :vehicle/extra-rims "Extra Rims"
     :vehicle/extra-tires "Extra Tires"
     :vehicle/height-mm "Height (mm)"
     :vehicle/hu-au-valid-until "HU/AU valid until"
     :vehicle/leaky? "Leaky"
     :vehicle/length-mm "Length (mm)"
     :vehicle/license-plate "License plate"
     :vehicle/make "Make"
     :vehicle/mileage "Mileage"
     :vehicle/model "Model"
     :vehicle/new? "New?"
     :vehicle/non-drivable? "Not drivable"
     :vehicle/permanently-quarantined? "Permanently quarantined"
     :vehicle/rims "Rims"
     :vehicle/stickers "Stickers"
     :vehicle/tires "Tires"
     :vehicle/vin "VIN"
     :vehicle/weight "Weight"
     :vehicle/width-mm "Width (mm)"
     :vehicle/transport-mode-active? "Transport mode active?"
     :vehicle.status/battery-charge "Battery Charge"
     :workflow/code "Workflow"
     :ductile/location "location"
     :ductile/comments "comments"
     :battery/ok "Battery OK"
     :battery/charge-needed "Battery needs charging"
     :battery/replacement-needed "Battery needs replacement"
     :battery/measurement-needed "Battery needs measurement"
     :battery/measurement-impossible "Battery measurement impossible"
     :battery/disconnected? "Battery disconnected"
     :high-voltage-battery-thermal-check/ok "O.K."
     :high-voltage-battery-thermal-check/not-ok "Not O.K."]))

(def default-column-order (map first (partition 2 translated-column-headers)))
(def translated-keys (reduce (fn [m [k v]] (assoc m k v)) {} (partition 2 translated-column-headers)))

(comment
  (count default-column-order)
  (count (set default-column-order))


  :rcf)

#?(:clj
   (defn ->java-locale [locale-keyword]
     (get {:de java.util.Locale/GERMAN
           :en java.util.Locale/UK
           :it java.util.Locale/ITALIAN}
          locale-keyword
          java.util.Locale/UK)))

#_(->java-locale :en)
#_(->java-locale :it)
#_(->java-locale :de)
#_(->java-locale :fi)

(defn trn [strings count & args]
  (let [[singular plural] strings]
    (if (= 1 count)
      ;; use fully qualified symbol here to avoid tr being picked up by `from-codebase`
      (apply ductile.ui.locale/tr singular (conj args count))
      (apply ductile.ui.locale/tr plural (conj args count)))))

(defn -pred-min-max-error-fn [{:keys [pred message]}]
  (fn [{:keys [schema value]} _]
    (let [{:keys [min max]} (m/properties schema)]
      (cond
        (not (pred value)) message
        (and min (= min max)) (tr "should be %1" min)
        (and min max) (tr "should be between %1 and %2" min max)
        min (tr "should be at least %1" min)
        max (tr "should be at most %1" max)))))

(defn malli-humanize [v]
  (let [locale (get-current-locale)]
    (me/humanize
     v
     {:locale locale
      :errors
      (merge me/default-errors
             {:int {:error/fn {locale (-pred-min-max-error-fn {:pred int? :message (tr "should be an integer")})}}
              :double {:error/fn {locale (-pred-min-max-error-fn {:pred double? :message (tr "should be a double")})}}
              :malli.core/missing-key {:error/message {locale (tr "missing")}}
              :malli.core/extra-key {:error/message {locale (tr "disallowed key")}}
              :enum {:error/fn {locale (fn [{:keys [schema value]} _]
                                         (let [children (m/children schema)]
                                           (str (cond (string? value) (str value " ")
                                                      (keyword? value) (str (tr value) " ")
                                                      :else nil)
                                                (if (= 1 (count children))
                                                  (str (tr "should be") " " (str (first children)))
                                                  (str (tr "should be either") " "
                                                       (->> (butlast children) (map str) (str/join ", "))
                                                       " " (tr "or") " " (str (last children)))))))}}})})))

#?(:cljs
   (defn ^:export throw-on-missing-translations []
     (when (seq @!missing-translations)
       (throw (js/Error. (str (count @!missing-translations)
                              " missing translations: " @!missing-translations))))))

(defn format-number
  ([n] (format-number nil n))
  ([opts n]
   (if (number? n)
     #?(:cljs (.format (js/Intl.NumberFormat.
                        (->iso-locale (or (:locale opts) (get-current-locale)))
                        (or (clj->js opts) #js {}))
                       n)
        :bb (str n) ; missing java.text.NumberFormat
        :clj (let [locale (->java-locale (or (:locale opts) (get-current-locale)))
                   formatter (java.text.NumberFormat/getInstance locale)]
               (.format formatter n)))
     n)))

(defn parse-price-cents [s]
  (let [raw (-> s str str/trim (str/replace #"[^0-9,\.\-]" ""))
        negative? (str/starts-with? raw "-")
        stripped (if negative? (subs raw 1) raw)
        last-comma (str/last-index-of stripped ",")
        last-dot (str/last-index-of stripped ".")
        dec-pos (max (or last-comma -1)
                     (or last-dot -1))

        [whole frac]
        (if (neg? dec-pos) ;; no decimal
          [stripped ""]
          [(subs stripped 0 (inc dec-pos))
           (subs stripped (inc dec-pos))])

        ;; remove thousand separators
        whole-clean (str/replace whole #"[,\.]" "")
        frac-clean (-> (str frac "00")  ; pad
                       (subs 0 2))]
    (when (re-find #"^\d+$" whole-clean)
      (let [w (parse-long whole-clean)
            f (parse-long frac-clean)
            cents (+ (* 100 w) f)]
        (if negative? (- cents) cents)))))

(defn parse-locale-double
  "Parses a locale-formatted number string (comma or dot as decimal separator).
   Strips spaces and thousand separators, returns a double or nil."
  [s]
  (let [raw (-> s str str/trim (str/replace #"\s+" ""))
        negative? (str/starts-with? raw "-")
        stripped (if negative? (subs raw 1) raw)
        last-comma (str/last-index-of stripped ",")
        last-dot (str/last-index-of stripped ".")
        dec-pos (max (or last-comma -1) (or last-dot -1))
        [whole frac] (if (neg? dec-pos)
                       [stripped nil]
                       [(subs stripped 0 dec-pos)
                        (subs stripped (inc dec-pos))])
        whole-clean (str/replace whole #"[,\.]" "")]
    (when (and (seq whole-clean) (re-find #"^\d+$" whole-clean))
      (let [n (parse-double (if frac (str whole-clean "." frac) whole-clean))]
        (if negative? (- n) n)))))

(defn parse-int [s]
  (-> s str (str/replace #"[^0-9]" "") parse-long))

(defn parse-number [parse-as s]
  (case parse-as
    :price-cents (parse-price-cents s)
    (parse-long s)))

(defn dissoc-nil [m]
  (into (empty m) (remove #(nil? (val %))) m))

(comment
  (select-language :sk)
  #?(:cljs (detect-browser-language))

  (set-locale! :sk)
  (set-locale! :de)
  (set-locale! :en)
  (set-locale! :it)

  (trple-get :it ["vehicle" "Fahrzeug" "vettura"])
  (trple-get :it [:vehicle "vehicle" "Fahrzeug" "vettura"])

  (get-in all-translations [:de :it "Fahrzeug"])

  (translate :en :de "vehicle")
  (translate :en :de :vehicle)
  (translate nil :de :vehicle)
  (translate nil :de "blah")

  (translate nil :de "%1 gebrauchte" [4])

  (replace-args "%1 vehicles" [4])
  (replace-args ":n vehicles" {:n 4}))
